// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"YearsSelectedTags-module__wrapper"};